/**
 * CalendarFilter — saisie directe des dates.
 *
 * ⚠️ Ces styles habillent un bloc inséré DANS le panneau du calendrier (`headerSlot`), et non dans
 * la carte du widget. C'est ce qui permet d'ajouter la saisie sans toucher à l'encombrement du
 * filtre : la disposition des pages est figée par une grille, et une rangée de plus dans la carte
 * décalerait tous les widgets en dessous.
 */
import styled from "styled-components"
import { colors, radius, spacing, typography } from "Shared/tokens"

export const SaisieBloc = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing[2]}px;
  padding: ${spacing[3]}px ${spacing[3]}px ${spacing[1]}px;
`

export const SaisieChamp = styled.input`
  flex: 1 1 110px;
  min-width: 0;
  padding: ${spacing[1.5]}px ${spacing[2]}px;
  border: 1px solid ${({ $invalide }) => ($invalide ? colors.status.error.icon : colors.borderInput)};
  border-radius: ${radius.sm}px;
  font-size: ${typography.bodySmall.size}px;
  color: var(--text-primary, ${colors.textPrimary});
  background: var(--white, ${colors.white});

  &::placeholder {
    color: var(--text-muted, ${colors.textMuted});
  }

  &:focus-visible {
    outline: 2px solid ${({ $couleur }) => $couleur};
    outline-offset: 1px;
  }
`

export const SaisieBouton = styled.button`
  padding: ${spacing[1.5]}px ${spacing[3]}px;
  border: 0;
  border-radius: ${radius.sm}px;
  font-size: ${typography.bodySmall.size}px;
  color: ${colors.white};
  background: ${({ $couleur }) => $couleur};
  cursor: pointer;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`
